import { Geometry, GeometryCollection } from 'geojson';

import { SnLonLat, SnLonLatBounds } from '@lib/geo/helpers';

export type QueryGeometry = SnLonLat | SnLonLatBounds | Exclude<Geometry, GeometryCollection>;
